import { render } from "./ChangeOrders.vue?vue&type=template&id=40b85408&scoped=true"
import script from "./ChangeOrders.vue?vue&type=script&lang=js"
export * from "./ChangeOrders.vue?vue&type=script&lang=js"

import "./ChangeOrders.vue?vue&type=style&index=0&id=40b85408&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b85408"]])

export default __exports__